import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { namespace: String }

  connect() {
    const frame = document.getElementById(`employments_${this.namespaceValue}`)
    frame?.reload?.()
  }
}
